<script setup>
    import ScrollUp from '@/components/parts/ScrollUp.vue'
</script>

<template>
    <div class="sidenav-overlay"></div>
    <div class="drag-target"></div>

    <ScrollUp />
</template>
